import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";


const initialState = {
  errors: null,
  isLoading: false,
  myProfessionData: [],
  allBeautyProfessionData: []
};


const ProfessionSlice = createSlice({
  name: "profession",
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setMyProfessionData: (state, action) => {
      state.myProfessionData = action.payload;
    },
    setAllBeautyProfessionData: (state, action) => {
      state.allBeautyProfessionData = action.payload;
    }
  },
});


export const myProfession = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = "professional/me";
    const response = await axiosInstance.get(URL);

    const { status } = response?.data || {};
    if (status === "success") {
      dispatch(setMyProfessionData(response?.data?.data));
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.message || error.message || "Something went wrong.";
    dispatch(setErrors({
      status: error?.response?.status,
      message: errorMsg
    }));
  }
};



export const allBeatyProfession = (subCategoryId) => async (dispatch) => {
  dispatch(setLoading(true))
  try {
    let URL = `discovery/subcategory/${subCategoryId}`;
    const response = await axiosInstance.get(URL);
    const { status } = response?.data || {};
    if (status === "success") {
      dispatch(setAllBeautyProfessionData(response?.data?.data))
    }

  } catch (error) {
    const errorMsg = error?.response?.data?.message || error.message || "Something went wrong.";
    dispatch(setErrors({
      status: error?.response?.status,
      message: errorMsg
    }));
  }
}


export const { setErrors, setLoading, setMyProfessionData, setAllBeautyProfessionData } = ProfessionSlice.actions;

export default ProfessionSlice.reducer;
